import { gql } from "@apollo/client";

export const OAR_FRAGMENT = gql`
  fragment oarFragment on OarType {
    prescriptionId
    templateId
    organ
    maxValue
    maxValueUnit
    meanValueUnit
    meanValue
    alara
    volumeConstraintData {
      firstValue
      firstValueUnit
      secondValue
      secondValueUnit
      operator
    }
    dConstraintData {
      dosetoPrefixOperator
      firstValue
      firstValueUnit
      secondValue
      secondValueUnit
      operator
    }
  }
`;

export const GET_ORGAN_LIST = gql`
  query organList($prescriptionId: ID!) {
    organList(prescriptionId: $prescriptionId) {
      id
      organ
    }
  }
`;

export const GET_OAR_TEMPLATE = gql`
  ${OAR_FRAGMENT}
  query oarTemplate($prescriptionId: ID!) {
    oarTemplate(prescriptionId: $prescriptionId) {
      ...oarFragment
    }
  }
`;

export const ADD_OAR = gql`
  mutation createOar(
    $prescriptionId: ID!
    $alara: Boolean
    $organ: String
    $volumeConstraintData: [OarConstraintInputType]
    $dConstraintData: [OarConstraintInputType]
    $maxValue: [Float]
    $maxValueUnit: String
    $meanValue: [Float]
    $meanValueUnit: String
  ) {
    createOar(
      prescriptionId: $prescriptionId
      alara: $alara
      organ: $organ
      maxValue: $maxValue
      maxValueUnit: $maxValueUnit
      meanValue: $meanValue
      meanValueUnit: $meanValueUnit
      volumeConstraintData: $volumeConstraintData
      dConstraintData: $dConstraintData
    ) {
      oar {
        prescriptionId
        organ
        maxValue
        maxValueUnit
        meanValue
        alara
        volumeConstraintData {
          firstValue
          firstValueUnit
          secondValue
          secondValueUnit
          operator
        }
        dConstraintData {
          dosetoPrefixOperator
          firstValue
          firstValueUnit
          secondValue
          secondValueUnit
          operator
        }
      }
    }
  }
`;

export const UPDATE_OAR = gql`
  mutation updateOar(
    $prescriptionId: ID!
    $index: ID!
    $alara: Boolean
    $organ: String
    $volumeConstraintData: [OarConstraintInputType]
    $dConstraintData: [OarConstraintInputType]
    $maxValue: [Float]
    $maxValueUnit: String
    $meanValue: [Float]
    $meanValueUnit: String
  ) {
    updateOar(
      prescriptionId: $prescriptionId
      index: $index
      alara: $alara
      organ: $organ
      maxValue: $maxValue
      maxValueUnit: $maxValueUnit
      meanValue: $meanValue
      meanValueUnit: $meanValueUnit
      volumeConstraintData: $volumeConstraintData
      dConstraintData: $dConstraintData
    ) {
      oar {
        prescriptionId
        organ
        maxValue
        alara
        maxValueUnit
        meanValue
        meanValueUnit
        volumeConstraintData {
          firstValue
          firstValueUnit
          secondValue
          secondValueUnit
          operator
        }
        dConstraintData {
          dosetoPrefixOperator
          firstValue
          firstValueUnit
          secondValue
          secondValueUnit
          operator
        }
      }
    }
  }
`;

export const DELETE_OAR = gql`
  mutation deleteOar($prescriptionId: ID!, $index: ID!) {
    deleteOar(prescriptionId: $prescriptionId, index: $index) {
      ok
    }
  }
`;

export const REPLACE_OARS = gql`
  mutation replaceOars(
    $prescriptionId: ID!
    $templateId: ID!
    $isSelectedForBulkEdit: Boolean!
  ) {
    replaceOars(
      prescriptionId: $prescriptionId
      templateId: $templateId
      isSelectedForBulkEdit: $isSelectedForBulkEdit
    ) {
      ok
    }
  }
`;
